<template>
  <div class="transaction-wrap">
    <div class="guide">
      <a href="yingtan/dist/html/navigation.html">首页 >></a>
      <router-link :to="{name: 'home'}">耕地利用大数据 >></router-link>
      <router-link :to="{name: 'transaction'}">土地流转</router-link>
    </div>
    <div class="conclusion-list">
      <div class="conclusion-item">
        <span>{{conclusion.area}}</span>
        <span>（万亩）</span>
        <p>土地流转面积</p>
        <i class="iconfont icon-mianji"></i>
      </div>
      <div class="conclusion-item">
        <span>{{conclusion.percent}}</span>
        <span>%</span>
        <p>土地流转面积占全国<br/>耕地面积比例</p>
        <i class="iconfont icon-bili"></i>
      </div>
      <div class="conclusion-item">
        <span>{{conclusion.dahu}}</span>
        <span>（万户）</span>
        <p>土地流转<br/>涉及专业大户</p>
        <i class="iconfont icon-dahu"></i>
      </div>
      <div class="conclusion-item">
        <span>{{conclusion.hezuoshe}}</span>
        <span>（万个）</span>
        <p>土地流转<br/>涉及合作社</p>
        <i class="iconfont icon-hezuoshe"></i>
      </div>
    </div>
    <div class="navs">
      <router-link class="nav-list" tag="a" :to="{name: 'area'}">流转面积分析</router-link>
      <router-link class="nav-list" tag="a" :to="{name: 'quantity'}">流转数量分析</router-link>
      <router-link class="nav-list" tag="a" :to="{name: 'price'}">流转价格分析</router-link>
      <router-link class="nav-list" tag="a" :to="{name: 'worth'}">土地价值评估指数分析</router-link>
      <router-link class="nav-list" tag="a" :to="{name: 'proportion'}">流转比例分析</router-link>
      <router-link class="nav-list" tag="a" :to="{name: 'whereabouts'}">流转去向及类型分析</router-link>
    </div>
    <router-view></router-view>
  </div>
</template>

<script type="text/javascript">

  export default {
    name: 'transaction',
    data() {
      return {
        conclusion: {
          area: 113080,
          percent: 10.8,
          dahu: 132,
          hezuoshe: 33
        }
      };
    },
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/css/lib-variable";
  @import "../../assets/css/lib-mixin";
  .transaction-wrap {
    width: 100%;
    height: 100%;
    .guide {
      a {
        color: #bffffb;
        @include animate();
        &:hover {
          color: #fff;
        }
      }
    }
    .conclusion-list {
      width: 100%;
      height: 110px;
      margin: 20px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .conclusion-item {
        width: calc((100% - 36px) / 4);
        height: 100%;
        background-color: #017c80;
        box-sizing: border-box;
        padding: 20px 20px 0;
        position: relative;
        span:nth-child(1) {
          font-size: 24px;
          font-weight: bold;
        }
        span:nth-child(2) {
          font-size: $fz-sr;
        }
        &:nth-child(1) {
          color: #5bdaff;
          border: 1px rgba(0,213,251,.7) solid;
          background-color: rgba(0,193,255,.35);
          p {
            color: #aad9e7;
          }
        }
        &:nth-child(2) {
          color: #35ece6;
          border: 1px rgba(53,236,230,.7) solid;
          background-color: rgba(49,210,225,.3);
          p {
            color: #7cc8c6;
          }
        }
        &:nth-child(3) {
          color: #eeed62;
          border: 1px rgba(214,255,91,.7) solid;
          background-color: rgba(255,240,0,.25);
          p {
            color: #d5d79b;
          }
        }
        &:nth-child(4) {
          color: #f6c038;
          border: 1px rgba(233,177,43,.83) solid;
          background-color: rgba(236,165,29,.3);
          p {
            color: #d1b87b;
          }
        }
        .iconfont {
          font-size: 72px;
          opacity: .6;
          position: absolute;
          right: 10px;
          bottom: -23px;
        }
      }
    }
    .navs {
      width: 100%;
      margin-bottom: 14px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .nav-list {
        color: #a1ffec;
        font-size: $fz-sm;
        font-weight: bold;
        cursor: pointer;
        height: 30px;
        line-height: 30px;
        box-sizing: border-box;
        padding: 0 26px;
        margin-right: 20px;
        border: 1px transparent solid;
        border-radius: 15px;
        @include animate();
        &:hover, &.active, &:focus {
          color: #fff;
          background: radial-gradient(50% 85%, #39b6ac 10%, rgba(255,255,255,0));
          border: 1px #2ac7c8 solid;
          border-radius: 15px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/transaction/transaction.vue